import type * as LoggerBundle from './index';
import { Logger, LoggerBackend } from './logger';
import { LoggerConfiguration, WILDCARD_NAMESPACE } from './logger-configuration';

export const PLAYER_LOG_QUERY_PARAM_KEY = 'playerLog';

type LoggerGlobal = {
  logger: Logger & { bundle: typeof LoggerBundle };
};

export function createLogger(
  foundationGlobal: LoggerGlobal,
  loggerConfig?: LoggerConfiguration,
  loggerBackend?: LoggerBackend,
) {
  const loggerBundle = foundationGlobal.logger.bundle;
  const url = new URL(location.href);
  const playerLogParam = url.searchParams.get(PLAYER_LOG_QUERY_PARAM_KEY);

  if (playerLogParam) {
    loggerConfig = loggerBundle.fromString(playerLogParam);
  }
  const rootLogger = new loggerBundle.LoggerImplementation(loggerConfig, WILDCARD_NAMESPACE, loggerBackend);

  // merge objects to preserve bundle
  foundationGlobal.logger = Object.assign(rootLogger, foundationGlobal.logger);

  const loaderLogger = rootLogger.getLogger('loader.createPlayer');

  if (loaderLogger.isLoggingActiveForLevel(loggerBundle.LogLevel.Debug)) {
    loaderLogger.debug('Logger initialized with config:', JSON.stringify(loggerConfig));
  }
}
